import Features from '@ui/components/Features';
import { LowCroBalanceDrawer } from '@ui/components/LowCroBalanceDrawer';
import { InDesktop, InMobile } from '@ui/components/MobileOrDesktop';
import { SEOTemplate } from '@ui/components/SEO';
import { UseYourTokenDrawer } from '@ui/components/useYourTokenDrawer';
import { COIN_MODE, useCoinMode } from '@ui/hooks/useCoinMode';
import { useRedirectFromHiddenPage } from '@ui/hooks/useRedirectFromHiddenPage';
import { StakeAndUseLcroView } from '@ui/views/StakeAndUseLcro';
import { ZKSYNC_ENABLED } from '@veno-app/wallet';
import type { NextPage } from 'next';

import { StakeAndUseLcroDesktop } from '../StakeAndUseLcro/StakeAndUseLcroDesktop';

export const Stake: NextPage = () => {
  const globalCoinMode = useCoinMode();
  const coinModeInfo = COIN_MODE[globalCoinMode];

  useRedirectFromHiddenPage();
  if (globalCoinMode === 'eth' && !ZKSYNC_ENABLED) return null;

  return (
    <>
      <SEOTemplate
        title={`Stake ${coinModeInfo.name} and earn validator rewards - Veno Finance`}
        description={`Stake your ${coinModeInfo.name} with Veno Finance and receive ${coinModeInfo.liquidName} in return.`}
      />
      <InMobile>
        <StakeAndUseLcroView />
      </InMobile>
      <InDesktop>
        <StakeAndUseLcroDesktop />
      </InDesktop>
      <Features.lowCroBalanceDrawer>
        <LowCroBalanceDrawer />
      </Features.lowCroBalanceDrawer>
      <UseYourTokenDrawer />
    </>
  );
};
